/**

Coded by www.techhighway.ca

*/

import { AuthContext } from "context";
import { useContext } from "react";

export default function authPermission() {
  const authContext = useContext(AuthContext);

  const hasPermission = (handler) => {
    const permissions = authContext.userPermission;
    if (localStorage.getItem("user_id") != 1) {
      if (typeof permissions[handler] !== 'undefined') {
        return permissions[handler];
      } else {
        return {
          view: null,
          status: null,
          new: null,
          edit: null,
          remove: null,
        };
      }
    } else {
      return {
        view: 1,
        status: 1,
        new: 1,
        edit: 1,
        remove: 1,
      };
    }
  };

  const systemConstant = (key) => {
    const parameter = authContext.systemParameters;
    let value = "";
    if (Object.keys(parameter).length > 0) {
      parameter.map((eachParameter) => {
        if (eachParameter.name == key) {
          value = eachParameter.value;
        }
      });
    }
    return value;
  };

  const getHandlerPath = (pathname, actions) => {
    const parts = pathname.split("/").filter(Boolean); // Removes empty strings

    // If last part is an action (like 'add' or 'edit'), remove it
    if (actions.includes(parts[parts.length - 1])) {
      parts.pop();
    }

    return "/" + parts.join("/");
  };

  return {
    hasPermission,
    systemConstant,
    getHandlerPath
  };
}
